export const QUERY_LIST_SUCCESS = 'QUERY_LIST_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const AUTH_SET_TOKEN = 'AUTH_SET_TOKEN';
export const QUERY_DETAIL_SUCCESS = 'QUERY_DETAIL_SUCCESS';
export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
